var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass:
          "mr10 bg-cl-primary brdr-1 brdr-cl-primary brdr-square h5 cl-tertiary generic-selector",
        class: [
          {
            active:
              _vm.isActiveVariant(_vm.variants[0].id) &&
              _vm.$route.meta.category === _vm.config.rootcategories.drukowanie
          },
          {
            active_office:
              _vm.isActiveVariant(_vm.variants[0].id) &&
              _vm.$route.meta.category === _vm.config.rootcategories.biuro
          }
        ],
        attrs: { "aria-label": _vm.$t("Select " + _vm.variant.label) },
        on: {
          click: function($event) {
            return _vm.$emit("change", _vm.variants[0])
          }
        }
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("Nie") || "Nie") + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "bg-cl-primary brdr-1 brdr-cl-primary brdr-square h5 cl-tertiary generic-selector",
        class: [
          {
            active:
              _vm.isActiveVariant(_vm.variants[1].id) &&
              _vm.$route.meta.category === _vm.config.rootcategories.drukowanie
          },
          {
            active_office:
              _vm.isActiveVariant(_vm.variants[1].id) &&
              _vm.$route.meta.category === _vm.config.rootcategories.biuro
          }
        ],
        attrs: { "aria-label": _vm.$t("Select " + _vm.variant.label) },
        on: {
          click: function($event) {
            return _vm.$emit("change", _vm.variants[1])
          }
        }
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("Tak") || "Tak") + "\n  ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }